import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const CountdownTimer: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 35,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const calculateTime = () => {
      const now = Date.now();
      const cycleMs = 36 * 60 * 60 * 1000; // 36 hours in milliseconds
      const elapsed = now % cycleMs;
      const remaining = cycleMs - elapsed;
      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor(remaining % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(remaining % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    // Initial calculation
    calculateTime();
    // Update every second
    const interval = setInterval(calculateTime, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="w-full max-w-3xl mx-auto my-8 md:my-12" data-id="element-285">
      <div className="flex flex-col items-center justify-center" data-id="element-286">
        {/* Header Text */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-287">
          <div className="inline-flex items-center justify-center gap-2 bg-green-500/10 border border-green-500/20 px-4 py-1.5 rounded-full mb-2 backdrop-blur-sm" data-id="element-288">
            <span className="text-green-500 text-sm md:text-base font-black tracking-wider uppercase flex items-center gap-2" data-id="element-289">
              ČASOVĚ OMEZENÁ NABÍDKA!
            </span>
          </div>
          <p className="text-gray-400 text-xs md:text-sm font-medium tracking-wide uppercase" data-id="element-290">
            Sleva končí za:
          </p>
        </motion.div>

        {/* Timer Grid */}
        <div className="flex items-start justify-center gap-2 md:gap-4" data-id="element-291">
          <TimeBlock value={formatNumber(timeLeft.hours)} label="HODINY" delay={0} data-id="element-292" />
          <Separator data-id="element-293" />
          <TimeBlock value={formatNumber(timeLeft.minutes)} label="MINUTY" delay={0.1} data-id="element-294" />
          <Separator data-id="element-295" />
          <TimeBlock value={formatNumber(timeLeft.seconds)} label="SEKUNDY" delay={0.2} data-id="element-296" />
        </div>
      </div>
    </div>;
};
interface TimeBlockProps {
  value: string;
  label: string;
  delay: number;
}
const TimeBlock: React.FC<TimeBlockProps> = ({
  value,
  label,
  delay
}) => {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.9
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.4
  }} className="flex flex-col items-center" data-id="element-297">
      <div className="relative group" data-id="element-298">
        {/* Glow effect behind */}
        <div className="absolute -inset-0.5 bg-gradient-to-b from-green-500/20 to-transparent rounded-xl blur opacity-50 group-hover:opacity-75 transition duration-500" data-id="element-299"></div>

        {/* Card Content */}
        <div className="relative bg-gray-900/80 backdrop-blur-xl border border-gray-800 rounded-xl p-3 md:p-5 min-w-[70px] md:min-w-[100px] shadow-2xl overflow-hidden flex flex-col items-center justify-center" data-id="element-300">
          {/* Subtle top highlight */}
          <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-green-500/30 to-transparent" data-id="element-301"></div>

          <div className="relative z-10 h-10 md:h-14 flex items-center justify-center overflow-hidden" data-id="element-302">
            <AnimatePresence mode="popLayout" data-id="element-303">
              <motion.span key={value} initial={{
              y: 20,
              opacity: 0,
              filter: 'blur(5px)'
            }} animate={{
              y: 0,
              opacity: 1,
              filter: 'blur(0px)'
            }} exit={{
              y: -20,
              opacity: 0,
              filter: 'blur(5px)'
            }} transition={{
              duration: 0.4,
              ease: [0.32, 0.72, 0, 1]
            }} className="block text-4xl md:text-6xl font-black text-white drop-shadow-[0_0_15px_rgba(22,163,74,0.4)] tracking-tight" data-id="element-304">
                {value}
              </motion.span>
            </AnimatePresence>
          </div>
        </div>
      </div>
      <span className="text-[10px] md:text-xs text-gray-500 font-bold tracking-[0.2em] mt-3 uppercase" data-id="element-305">
        {label}
      </span>
    </motion.div>;
};
const Separator: React.FC = () => <div className="h-[70px] md:h-[100px] flex items-center justify-center pt-2 md:pt-4" data-id="element-306">
    <motion.span animate={{
    opacity: [1, 0.5, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className="text-green-500 text-2xl md:text-4xl font-black" data-id="element-307">
      :
    </motion.span>
  </div>;